import { elaineMediaArray } from './elaineMedia'
import { elaineBio } from './elaineBios'

import { georgeReviewerReviewHinge, jerryReviewerReviewBumble, kramerReviewerReviewTinder } from './elaineReviewerReviews'
import { georgeReviewerProfile, jerryReviewerProfile, kramerReviewerProfile } from './elaineReviewers'

export const georgeProfileReviewHinge = {
  _id: 'georgeProfileReviewHingeId',
  userId: 'elaineUserId',
  userEmail: 'elaine@email.com',
  datingProfileId: 'elaineDatingProfileHingeId',
  reviewerProfileId: 'georgeReviewerProfileId',
  reviewerEmail: 'george@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'hinge',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: elaineMediaArray[16]._id,
      mediaItemURL: elaineMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[16].type,
      caption: elaineMediaArray[16].captions[2],
      subcaption: elaineMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[2]._id,
      mediaItemURL: elaineMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[2].type,
      caption: elaineMediaArray[2].captions[1],
      subcaption: elaineMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[1]._id,
      mediaItemURL: elaineMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[1].type,
      caption: elaineMediaArray[1].captions[2],
      subcaption: elaineMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[12]._id,
      mediaItemURL: elaineMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[12].type,
      caption: elaineMediaArray[12].captions[2],
      subcaption: elaineMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[7]._id,
      mediaItemURL: elaineMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[7].type,
      caption: elaineMediaArray[7].captions[1],
      subcaption: elaineMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[13]._id,
      mediaItemURL: elaineMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[13].type,
      caption: elaineMediaArray[13].captions[0],
      subcaption: elaineMediaArray[13].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look good here, but it's a bit staged. A more natural background would be getter`,
      verdict: 'Yes',
    },
    {
      feedback: `Looking cool and successful, but it's not your most flattering picture. Still a good change of pace, maybe put it lower on the profile`,
      verdict: 'Yes',
    },
    {
      feedback: `This is funny, shows you're able to laugh at yourself, and you look good in spite of the lipstick error`,
      verdict: 'Yes',
    },
    {
      feedback: `You look cool but photos with other guys, especially guys you used to date, are a BIG NO, no matter what`,
      verdict: 'No',
    },
    {
      feedback: `Guys will zoom in on the nipple and think of you as a one-nighter, not as a potential life partner`,
      verdict: 'No',
    },
    {
      feedback: `Funny caption, and you look good, though maybe find something where you're smiling to balance out the rest of the profile`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: elaineBio._id,
    vitalInfo: { ...elaineBio.vitalInfo },
    prompts: [
      { ...elaineBio.prompts[0] },
      { ...elaineBio.prompts[1] },
      { ...elaineBio.prompts[2] }
    ],
    aboutMe: '',
    hobbies: [],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You're well oriented, at least on paper`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: '',
      verdict: '', 
    },
    promptsFeedback: [
      {
        feedback: `Golddigger vibes — people with actual gold will be put off by this... you gotta mask it better`,
        verdict: 'No', 
      },
      {
        feedback: `Anyone who sees you dance will immediately leave the date`,
        verdict: 'No', 
      },
      {
        feedback: `Good conversation starter. Maybe include a muffin tops picture too`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Elaine is funny and pretty but maybe a bit loose with her morals`,
    good: `You look good in a lot of the photos and you have self-deprecating humor in the captions that are appealing`,
    notGood: `The golddiggery prompt responses and the nipple pic should be replaced. Maybe add a photo of you smiling or holding a muffin top in it's place`,
    verdict: `Elaine's profile doesn't show her most attractive self at the moment, though, with some easy fixes she could vastly improve her profile within minutes`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...georgeReviewerReviewHinge },
  reviewerProfile: { ...georgeReviewerProfile },
  bioItems: { ...elaineBio },
  mediaItems: [ ...elaineMediaArray ],
}

export const jerryProfileReviewBumble = {
  _id: 'jerryProfileReviewBumbleId',
  userId: 'elaineUserId',
  userEmail: 'elaine@email.com',
  datingProfileId: 'elaineDatingProfileBumbleId',
  reviewerProfileId: 'jerryReviewerProfileId',
  reviewerEmail: 'jerry@email.com',
  isAIReview: true,
  isFriendReview: false,
  nameOfLLM: 'ChatGPT + Gemini',
  modelOfLLM: 'GPT-4o mini + gemini-1.5-flash-8b',
  priceOfReview: 10,
  reviewSubmitted: true,
  type: 'bumble',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: elaineMediaArray[16]._id,
      mediaItemURL: elaineMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[16].type,
      caption: elaineMediaArray[16].captions[2],
      subcaption: elaineMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[2]._id,
      mediaItemURL: elaineMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[2].type,
      caption: elaineMediaArray[2].captions[1],
      subcaption: elaineMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[1]._id,
      mediaItemURL: elaineMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[1].type,
      caption: elaineMediaArray[1].captions[2],
      subcaption: elaineMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[12]._id,
      mediaItemURL: elaineMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[12].type,
      caption: elaineMediaArray[12].captions[2],
      subcaption: elaineMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[7]._id,
      mediaItemURL: elaineMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[7].type,
      caption: elaineMediaArray[7].captions[1],
      subcaption: elaineMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[13]._id,
      mediaItemURL: elaineMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[13].type,
      caption: elaineMediaArray[13].captions[0],
      subcaption: elaineMediaArray[13].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look good here, but it's a bit staged. A more natural background would be getter`,
      verdict: 'Yes',
    },
    {
      feedback: `Looking cool and successful, but it's not your most flattering picture. Still a good change of pace, maybe put it lower on the profile`,
      verdict: 'Yes',
    },
    {
      feedback: `This is funny, shows you're able to laugh at yourself, and you look good in spite of the lipstick error`,
      verdict: 'Yes',
    },
    {
      feedback: `You look cool but photos with other guys, especially guys you used to date, are a BIG NO, no matter what`,
      verdict: 'No',
    },
    {
      feedback: `Guys will zoom in on the nipple and think of you as a one-nighter, not as a potential life partner`,
      verdict: 'No',
    },
    {
      feedback: `Funny caption, and you look good, though maybe find something where you're smiling to balance out the rest of the profile`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: elaineBio._id,
    vitalInfo: { ...elaineBio.vitalInfo },
    prompts: [
      { ...elaineBio.prompts[0] },
      { ...elaineBio.prompts[1] },
      { ...elaineBio.prompts[2] }
    ],
    aboutMe: elaineBio.aboutMe[0],
    hobbies: [elaineBio.hobbies[0], elaineBio.hobbies[1], elaineBio.hobbies[2], elaineBio.hobbies[3], elaineBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You're well oriented, at least on paper`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: 'Kind of funny... I like the attempt at humor at least',
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `Golddigger vibes — people with actual gold will be put off by this... you gotta mask it better`,
        verdict: 'No', 
      },
      {
        feedback: `Anyone who sees you dance will immediately leave the date`,
        verdict: 'No', 
      },
      {
        feedback: `Good conversation starter. Maybe include a muffin tops picture too`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Elaine is funny and pretty but maybe a bit loose with her morals`,
    good: `You look good in a lot of the photos and you have self-deprecating humor in the captions that are appealing`,
    notGood: `The golddiggery prompt responses and the nipple pic should be replaced. Maybe add a photo of you smiling or holding a muffin top in it's place`,
    verdict: `Elaine's profile doesn't show her most attractive self at the moment, though, with some easy fixes she could vastly improve her profile within minutes`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...jerryReviewerReviewBumble },
  reviewerProfile: { ...jerryReviewerProfile },
  bioItems: { ...elaineBio },
  mediaItems: [ ...elaineMediaArray ],
}

export const kramerProfileReviewTinder = {
  _id: 'kramerProfileReviewTinderId',
  userId: 'elaineUserId',
  userEmail: 'elaine@email.com',
  datingProfileId: 'elaineDatingProfileTinderId',
  reviewerProfileId: 'kramerReviewerProfileId',
  reviewerEmail: 'kramer@email.com',
  isAIReview: false,
  isFriendReview: false,
  nameOfLLM: 'NA',
  modelOfLLM: 'NA',
  priceOfReview: 80,
  reviewSubmitted: true,
  type: 'tinder',
  // vibes: ['classy', 'fun', 'relaxed'],
  media: [
    {
      mediaItemId: elaineMediaArray[16]._id,
      mediaItemURL: elaineMediaArray[16].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[16].type,
      caption: elaineMediaArray[16].captions[2],
      subcaption: elaineMediaArray[16].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[2]._id,
      mediaItemURL: elaineMediaArray[2].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[2].type,
      caption: elaineMediaArray[2].captions[1],
      subcaption: elaineMediaArray[2].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[1]._id,
      mediaItemURL: elaineMediaArray[1].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[1].type,
      caption: elaineMediaArray[1].captions[2],
      subcaption: elaineMediaArray[1].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[12]._id,
      mediaItemURL: elaineMediaArray[12].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[12].type,
      caption: elaineMediaArray[12].captions[2],
      subcaption: elaineMediaArray[12].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[7]._id,
      mediaItemURL: elaineMediaArray[7].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[7].type,
      caption: elaineMediaArray[7].captions[1],
      subcaption: elaineMediaArray[7].subcaptions[0],
    },
    {
      mediaItemId: elaineMediaArray[13]._id,
      mediaItemURL: elaineMediaArray[13].url,
      mediaItemDuration: -1,
      mediaItemThumbnail: 'NA',
      mediaType: elaineMediaArray[13].type,
      caption: elaineMediaArray[13].captions[0],
      subcaption: elaineMediaArray[13].subcaptions[0],
    }
  ],
  mediaFeedback: [
    {
      feedback: `You look good here, but it's a bit staged. A more natural background would be getter`,
      verdict: 'Yes',
    },
    {
      feedback: `Looking cool and successful, but it's not your most flattering picture. Still a good change of pace, maybe put it lower on the profile`,
      verdict: 'Yes',
    },
    {
      feedback: `This is funny, shows you're able to laugh at yourself, and you look good in spite of the lipstick error`,
      verdict: 'Yes',
    },
    {
      feedback: `You look cool but photos with other guys, especially guys you used to date, are a BIG NO, no matter what`,
      verdict: 'No',
    },
    {
      feedback: `Guys will zoom in on the nipple and think of you as a one-nighter, not as a potential life partner`,
      verdict: 'No',
    },
    {
      feedback: `Funny caption, and you look good, though maybe find something where you're smiling to balance out the rest of the profile`,
      verdict: 'Yes',
    }
  ],
  bio: {
    bioItemsId: elaineBio._id,
    vitalInfo: { ...elaineBio.vitalInfo },
    prompts: [
      { ...elaineBio.prompts[0] },
      { ...elaineBio.prompts[1] },
      { ...elaineBio.prompts[2] }
    ],
    aboutMe: elaineBio.aboutMe[0],
    hobbies: [elaineBio.hobbies[0], elaineBio.hobbies[1], elaineBio.hobbies[2], elaineBio.hobbies[3], elaineBio.hobbies[4]],
  },
  bioFeedback: {
    vitalInfoFeedback: {
      feedback: `You're well oriented, at least on paper`,
      verdict: 'Yes', 
    },
    aboutMeFeedback: {
      feedback: 'Kind of funny... I like the attempt at humor at least',
      verdict: 'Yes', 
    },
    promptsFeedback: [
      {
        feedback: `Golddigger vibes — people with actual gold will be put off by this... you gotta mask it better`,
        verdict: 'No', 
      },
      {
        feedback: `Anyone who sees you dance will immediately leave the date`,
        verdict: 'No', 
      },
      {
        feedback: `Good conversation starter. Maybe include a muffin tops picture too`,
        verdict: 'Yes', 
      }
    ],
  },
  generalFeedback: {
    vibe: `Elaine is funny and pretty but maybe a bit loose with her morals`,
    good: `You look good in a lot of the photos and you have self-deprecating humor in the captions that are appealing`,
    notGood: `The golddiggery prompt responses and the nipple pic should be replaced. Maybe add a photo of you smiling or holding a muffin top in it's place`,
    verdict: `Elaine's profile doesn't show her most attractive self at the moment, though, with some easy fixes she could vastly improve her profile within minutes`,
    unusedGoodImages: [],
    unusedGoodBioItems: [],
  },
  reviewerReview: { ...kramerReviewerReviewTinder },
  reviewerProfile: { ...kramerReviewerProfile },
  bioItems: { ...elaineBio },
  mediaItems: [ ...elaineMediaArray ],
}